import Sequence, { getSequenceHeight } from './Sequence';
export { getSequenceHeight };
export default Sequence;
